module.exports = __webpack_public_path__ + "img/PT63.0dd082d3.png";